export function applyProviders<Type>(
  initialComponent,
  providers: Function[],
): Type {
  return providers.reverse().reduce((component, withProvider) => {
    return withProvider(component);
  }, initialComponent);
}
